import { PermissionKey } from './../../../../shared/constants/permissionCode';
import { KEYS } from 'src/app/shared/constants/keys';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ClientModel } from '../client.service';
import { DataService } from 'src/app/shared/services/data.service';
import { Api } from 'src/app/shared/constants/api';
import { NGXLogger } from 'ngx-logger';


@Component({
    selector: 'app-client-view',
    templateUrl: './client-view.component.html',
    styleUrls: ['./client-view.component.less'],
    standalone: false
})
export class ClientViewComponent implements AfterViewInit {
  myForm: FormGroup;
  clientColumns: string[] = ["clientCode", "clientName", 'country', 'status', 'action'];
  filterValues = {
    clientCode: "",
    clientName: ""
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  clients = new MatTableDataSource<ClientModel>();
  permissions = [];
	addPermission : boolean = false;
	editPermission : boolean = false;
	viewPermission : boolean = false;
  constructor(public router: Router,
    private formBuilder: FormBuilder,
    private service: DataService,
    private logger: NGXLogger) {
    this.clients.filterPredicate = this.createFilter();
    logger.info('in constructor');
  }
  ngOnInit(): void {
    this.reactiveForm();
    this.clientPermission(PermissionKey.CLIENT_MODULE);
    	this.checkAllPermission();
  }
  reactiveForm() {
    this.myForm = this.formBuilder.group({
      codeFilter: [null],
      nameFilter: [null],
    })
  }


  ngAfterViewInit() {
    this.clients.paginator = this.paginator;
    this.clients.sort = this.sort;
    this.setClientCodeChangeEvent();
    this.setClientNameChangeEvent();
    this.getClientList();
  }
  
  private setClientCodeChangeEvent() {
    this.myForm.controls.codeFilter.valueChanges.subscribe(clientCode => {

      this.filterValues.clientCode = String(clientCode).toLowerCase();
      this.logger.info('client code ', this.filterValues);
      this.clients.filter = JSON.stringify(this.filterValues);
      this.getClientList({'code': this.filterValues.clientCode});
    });
  }

  private setClientNameChangeEvent() {
    this.myForm.controls.nameFilter.valueChanges.subscribe(clientName => {
      this.filterValues.clientName = String(clientName).toLowerCase();
      this.clients.filter = JSON.stringify(this.filterValues);
      this.getClientList({'name': this.filterValues.clientName});
    });
  }

  createFilter(): (dataList: ClientModel, filter: string) => boolean {
    let filterFunction = function (dataList, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (
        dataList.clientCode.toLowerCase().indexOf(searchTerms.clientCode) !== -1 &&
        dataList.clientName.toLowerCase().indexOf(searchTerms.clientName) !== -1
      );
    };
    return filterFunction;
  }
  createClient() {
    this.router.navigate(['masters/operational/client/add']);
  }
  editClient(clientId:number){
    this.logger.info('Editing client id ', clientId);
    this.router.navigate(['masters/operational/client/edit/'+clientId]);
  }

  getClientList(search?:any){
    this.service.get(Api.CLIENT, search).subscribe(res => {
      if (res && res.contents) {
        this.logger.info('Client list res ', res)
        this.clients = res.contents;
      }
    });
  }

  private clientPermission(sectorModuleKey: string) {
		let data = this.permissionMap;
		this.permissions = data.get(sectorModuleKey);
		this.logger.info("permission based on sector : ", this.permissions);
	  }
	
	  get permissionMap() {
		var permissionJson = JSON.parse(localStorage.getItem(KEYS.PERMISSION_DATA));
		this.logger.info("permission ---->  : ", permissionJson);
		let permissionMap = new Map<string, any>();
		for (var value in permissionJson) {
		  permissionMap.set(value, permissionJson[value]);
		}
		return permissionMap;
	  }
	
	  /**
	   * checkPermissionByCode
	   */
	  public checkPermissionByCode(permissionCode?: string) {
		if (this.permissions.includes(permissionCode)) {
		  this.logger.info("permission code is : ", permissionCode);
		  this.logger.info("permission list : ", this.permissions);
		  this.logger.info("permission is present in permission list");
		  return true;
		} else {
		  this.logger.info("permission code is : ", permissionCode);
		  this.logger.info("permission list : ", this.permissions);
		  this.logger.info("permission not present in permission list");
		  return false;
		}
	  }
	
	  public checkPermissionForAdd() {
		return this.addPermission = this.checkPermissionByCode(PermissionKey.CLIENT_MODULE_ADD_PERMISSION);
	  }
	
	  public checkPermissionForEdit() {
		return this.editPermission = this.checkPermissionByCode(PermissionKey.CLIENT_MODULE_EDIT_PERMISSION);
	  }
	  public checkPermissionForView() {
		return this.viewPermission = this.checkPermissionByCode(PermissionKey.CLIENT_MODULE_VIEW_PERMISSION);
	  }
	
	  public checkAllPermission(){
		this.checkPermissionForAdd();
		this.checkPermissionForEdit();
		this.checkPermissionForView();
	  }
}
